import {
  UseMutationResult,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { axiosInstance } from 'hooks/auth/AxiosInstance';
import { CaseCheckerActionResponse } from 'utils/types';

type AcceptCaseCheckerFine = {
  fineId: string;
};

const acceptCaseCheckerFine = async ({
  fineId,
}: AcceptCaseCheckerFine): Promise<CaseCheckerActionResponse> => {
  const response: AxiosResponse<CaseCheckerActionResponse> =
    await axiosInstance.post(`fine/${fineId}/case-checker/accept`);
  return response.data;
};

const useAcceptCaseCheckerFine = (): UseMutationResult<
  CaseCheckerActionResponse,
  Error,
  AcceptCaseCheckerFine
> => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: acceptCaseCheckerFine,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['fine'] });
      queryClient.invalidateQueries({
        queryKey: ['case-checker-pending-cases'],
      });
    },
    onError: (error: Error) => {
      console.error('Error accepting case checker fine:', error.message);
    },
  });
};

export default useAcceptCaseCheckerFine;
